import React from 'react';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks'
import { ApolloProvider } from 'react-apollo';
import { ThemeProvider } from 'styled-components';
import { client as apolloClient } from '../documents/Layout';
import EtranLanding from './EtranLanding';

const theme = {
  text: '#56565A',
  link: '#3399CC',
  linkHover: '#ce7019',
  white: '#FFFFFF',
  border: '#9B9B9B',
};

const EtranLayout = ({
  loanId,
  paycheck_protection,
  etran_via_api,
  cavirs_result_screen,
  ...documentBucketOptions
}) => (
  <ApolloHooksProvider client={apolloClient}>
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={theme}>
        <EtranLanding
          loanId={loanId}
          paycheck_protection={paycheck_protection}
          etran_via_api={etran_via_api}
          cavirs_result_screen={cavirs_result_screen}
          documentBucketOptions={documentBucketOptions}
        />
      </ThemeProvider>
    </ApolloProvider>
  </ApolloHooksProvider >
);

export default EtranLayout;
